import type { Extend } from '@mentimeter/ragnar-dsc';
import type { PresenceUser } from '@mentimeter/editor-realtime';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';

const capitalize: Extend = () => ({ textTransform: 'capitalize' });

interface CollaboratorInfoProps {
  collaborator: PresenceUser;
  userEmail?: string | undefined;
}

export const CollaboratorInfo = ({
  collaborator,
  userEmail,
}: CollaboratorInfoProps) => {
  return (
    <Box alignItems="inherit" width="100%">
      <Text fontSize="87.5" color="text" truncate>
        {collaborator.name || collaborator.email || (
          <Text fontSize="inherit" color="inherit" extend={capitalize}>
            {collaborator.actor}
          </Text>
        )}
        {collaborator.email === userEmail && ' (me)'}
      </Text>
      <Text fontSize="75" color="textWeak" extend={capitalize}>
        {collaborator.status}
      </Text>
    </Box>
  );
};
